// Desc: API calls for GET Requests

import { ADDRESS_URL, API_BASE_URL, EVENT_DATA, EVENT_ICS, ORDERS, SPECIAL_TAGS, SPECIAL_TAGS_PHOTOS } from "./apiURl";
import { commonHeaders, getRequest } from "./httpHelper";
import api from "../utils/request";

export const getAddressDataAPI = async () => {
  try {
    const response = await getRequest({
      url: ADDRESS_URL,
      headers: commonHeaders
    });
    return response;
  } catch (error) {
    console.error("Error fetching address data:", error);
    return null;
  }
};

export const getRequiredAddresTypeAPI = async (addressType) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/api/v6/parent/cart/get-required-address-type/`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching address data:", error);
    return error;
  }
};

export const getProductData = async (eventData) => {
  const { eventId, accessId, albumId, photoId } = eventData;
  const url = `${EVENT_DATA}/${eventId}/?access_id=${accessId}&album_id=${albumId}&photo_id=${photoId}`;

  try {
    const response = await getRequest({
      url: url,
      headers: commonHeaders
    });
    return response.data;
  } catch (error) {
    return {};
  }
};

export const getCustomerOffersAPI = async () => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/api/v6/parent/cart/customer-offers/`
    );
    return response;
  } catch (error) {
    console.error("Error fetching offers data:", error);
    return error;
  }
};

export const applyOfferAPI = async (offerData) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/api/v6/parent/cart/apply-offer/`,
      { params: offerData }
    );
    return response;
  } catch (error) {
    console.error("Error applying offer:", error);
    return error;
  }
};

export const getEventIcsAPI = async (payload) => {
  const { accessId, accessCode, orgId, eventSlug, mode } = payload;

  try {
    const response = await getRequest({
      url: `${EVENT_ICS}/?access_id=${accessId}&access_code=${accessCode}&org_id=${orgId}&event_slug=${eventSlug}&mode=${mode}`,
      headers: commonHeaders
    });

    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    if (mode === "google_url" || mode === "outlook_url") {
      if (isMobile) {
        window.location.href = response.data[`${mode}`];
      } else {
        window.open(response.data[`${mode}`], "_blank");
      }
    } else if (mode === "ics_file") {
      if (isMobile) {
        const blob = new Blob([response.data], { type: "text/calendar" });
        const url = URL.createObjectURL(blob);
        window.location.href = url;

        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      } else {
        const blob = new Blob([response.data], { type: "text/calendar" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${eventSlug}.ics`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    }
  } catch (error) {
    console.error("Error fetching ICS data:", error);
  }
};


// export const getParentOrdersAPI = async () => {
//   console.log("Get Customer orders ");
//   try {
//     const resp = api.get(`${API_BASE_URL}/api/v6/purchase-orders/0/get_customer_purchase_orders/`);
//     console.log("Parent orders resp ", resp);
//     return resp;
//   } catch (error) {
//     console.log("error ", error);
//     return error;
//   }
// };

export const getCustomerPurchaseOrdersAPI = async () => {
  try {
    const response = await api.get(`${ORDERS}/get_customer_purchase_orders/`);
    return response.data;
  } catch (error) {
    console.log(" api fail for orders:: ", error);
    return error;
  }
};

export const downloadHDInOrderAPI = async (orderProductId) => {
  try {
    const response = await api.get(`${ORDERS}/download_hd_in_order/?order_product_id=${orderProductId}&referrer=pixcart`);
    return response.data;
  } catch (error) {
    console.log(" api fail for orders hd :: ", error);
  }
};

export const getSpecialProductTagsAPI = async () => {
  try {
    const response = await api.get(SPECIAL_TAGS);
    console.log("responseeeee:::: ", response);
    return response.data.special_tags;
  } catch (error) {
    console.error("Error fetching special product tags:", error);
    return error;
  }
};

export const getSpecialTagsPhotosAPI = async (config = {}) => {
  try {
    const response = await api.get(SPECIAL_TAGS_PHOTOS, config);
    console.log("spcl tag photos::: ", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching special tags photos:", error);
    return error;
  }
};
